(function(){
     'use strict';

     angular
        .module('app')
        .factory('HistorialService', HistorialService);

    HistorialService.$inject = ['$http'];

    function HistorialService($http,$q,$window,$location){

        var history= {
           getPacientes:getPacientes,
           pacienteId:pacienteId,
           getSexos:getSexos,
           editPaciente:editPaciente
        };

 		function getPacientes(vm)
        {
            // console.log(vm);
            var config = {headers : {}}

            return $http.get('/ajax/resumenpacientes', {   
                params : { 
                    filtros:JSON.stringify(vm.filtros)
                }
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        function pacienteId(paciente_id,videoconsulta_id){

            var config = {
                headers : {}
            }

            return $http.get('/ajax/pacienteseleccionado', { 
                params : { 
                    paciente_id:paciente_id,
                    videoconsulta_id:videoconsulta_id
                } 
             }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

       function getSexos(vm)
        {
            var config = {headers : {}}

            return $http.get('/ajax/sexos', {   
            }, config)
            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

       

        function editPaciente(vm){
            var config = {
                headers : {
                   // 'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }
            
            return $http.post('/ajax/editarpaciente', {
                    paciente:JSON.stringify(vm.paciente)
             }, config)

            .then(function(data){
                return data.data;
            },function(data){
                return data;
            });
        };

        return history;
    }

})();